import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=167a45ca"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsOverlay: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Overlay.vue').default,Cart: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Index.vue').default,CartMobile: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Mobile.vue').default})
